import request from '@/plugins/axios'

// 查询流程分页
export function auditProcessPage(data) {
    return request({
        url: '/sys/auditProcess/v1.0.0/page',
        method: 'post',
        data: data
    })
}

// 查询流程列表
export function auditProcessList(data) {
    return request({
        url: '/sys/auditProcess/v1.0.0/list',
        method: 'post',
        data: data
    })
}

// 查询流程详细
export function auditProcessDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcess/v1.0.0/detail',
        method: 'post',
        data
    })
}

export function auditProcessAdd(data) {
    return request({
        url: '/sys/auditProcess/v1.0.0/add',
        method: 'post',
        data
    })
}

export function auditProcessUpdate(data) {
    return request({
        url: '/sys/auditProcess/v1.0.0/update',
        method: 'post',
        data
    })
}

export function auditProcessDelete(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/auditProcess/v1.0.0/delete',
        method: 'post',
        data
    })
}
